import { styled } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";

import { useTranslation } from "@/lib/i18n";

const Label = styled("div")(({ theme }) => ({
  background: "rgba(0, 0, 0, .1)",
  borderRadius: 4,
  padding: "6px 12px",
  position: "absolute",
  left: "50%",
  top: "calc(50% - 24px)",
  transform: "translateX(-50%) translateY(-50%)",
  fontSize: theme.typography.body1.fontSize,
}));

const NoDataLabel = ({ children }: PropsWithChildren) => {
  return <Label>{children}</Label>;
};

export default NoDataLabel;

interface NoDataOverlayProps {
  active: boolean;
  children: ReactNode;
}

export function NoDataOverlay({ active, children }: NoDataOverlayProps) {
  const { t } = useTranslation();
  return (
    <div style={{ position: "relative" }}>
      {children}
      {active && <NoDataLabel>{t("general.no_data")}</NoDataLabel>}
    </div>
  );
}
